import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { SetPasswordInformation } from './models/set-password-information.model';
import { MustMatchDirective } from '../core/validators.model'
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { FocusMeDirective } from '../core/focus-me/focus-me.directive';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styles: [
  ]
})
export class SetPasswordComponent implements OnInit, OnDestroy {

  @ViewChild(NgForm) setPasswordForm!: NgForm;

  doneLoading: boolean = false;
  submitAttempt: boolean = false;
  pageMode: string = 'setPassword';
  login: SetPasswordInformation = new SetPasswordInformation();

  constructor(@Inject(DOCUMENT) private document: Document,
    private ajax: ajaxCall,
    private router: Router,
    private notifier: NotifierService,
    private route: ActivatedRoute) {
    this.document.body.classList.add('login');

    this.login.passwordStrength = 0;
  }

  ngOnInit(): void {
    this.login.resetId = this.route.snapshot.paramMap.get('resetId');
    this.ajax.MakeCall<boolean>('/Login/VerifyLink', this.login)
      .then(() => { },
        () => { this.router.navigateByUrl('/login'); })
      .finally(() => {
        this.doneLoading = true;
      });

  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('login');
  }

  doSetPassword(): void {
    this.submitAttempt = true;
    if (this.setPasswordForm.invalid) {
      return;
    }

    this.ajax.MakeCall<void>('/Login/SetPassword', this.login).then(() => {
      this.notifier.notify('success', 'Your password has been set.');
      this.router.navigateByUrl('/login');
    }, () => {
    });

  }

  strengthChanged(evt: number) {
    this.login.passwordStrength = evt;
  }
}
